import { Guid } from 'guid-typescript'
import { DadosDatas, dadosDatasValorDefault } from './Datas'
import { DadosDespesasAcessorias, dadosDespesasAcessoriasValorDefault } from './DespesasAcessorias'
import { DadosGarantias, dadosGarantiasValorDefault } from './Garantias'
import { DadosParcela } from './Parcela'
import { DadosPermuta, dadosPermutaValorDefault } from './Permuta'

export type DadosCompraTerreno = {
  despesasAcessorias: DadosDespesasAcessorias
  garantias: DadosGarantias
  torna: DadosParcela[]
  permuta: DadosPermuta
  datas: DadosDatas
  id: Guid
}

export const dadosCompraTerrenoValorDefault = {
  despesasAcessorias: dadosDespesasAcessoriasValorDefault,
  garantias: dadosGarantiasValorDefault,
  torna: [],
  permuta: dadosPermutaValorDefault,
  datas: dadosDatasValorDefault,
  id: Guid.createEmpty()
} as DadosCompraTerreno
